/**
 * Frontend Medicine Helper Functions
 *
 * Pure functions for medicine data transformation and validation
 * Mirrors backend logic in server/src/utils/medicineHelpers.ts
 */

/**
 * Transform bulk upload errors into Excel-ready row format
 * Extracts medicine data and error reason into a flat structure
 * suitable for Excel export
 *
 * @param {Array} errors - Array of error objects from bulk upload response
 * @returns {Array} Array of objects with medicine fields + reason column
 */
export const transformErrorsToExcelRows = (errors) => {
  return errors.map((error) => {
    const medicine = error.data || {};
    return {
      "Row": error.row,
      "Company": medicine.company || "",
      "Product": medicine.product || "",
      "Strength": medicine.strength || "",
      "Dosage Form": medicine.dosageForm || "",
      "Pack Size": medicine.packSize || "",
      "Selling Price": medicine.sellingPrice || "",
      "Schedule": medicine.schedule || "",
      "Generic Name": medicine.genericName || "",
      "NAPPI Code": medicine.nappiCode || "",
      "Category": medicine.category || "",
      "Notes": medicine.notes || "",
      "Reason": error.error || "Unknown error",
    };
  });
};

/**
 * Get Excel column width configuration for error report
 * Returns array of column width objects for XLSX library
 *
 * @returns {Array} Array of column width objects
 */
export const getErrorReportColumnWidths = () => {
  return [
    { wch: 6 },  // Row
    { wch: 20 }, // Company
    { wch: 25 }, // Product
    { wch: 12 }, // Strength
    { wch: 15 }, // Dosage Form
    { wch: 12 }, // Pack Size
    { wch: 15 }, // Selling Price
    { wch: 10 }, // Schedule
    { wch: 20 }, // Generic Name
    { wch: 15 }, // NAPPI Code
    { wch: 15 }, // Category
    { wch: 30 }, // Notes
    { wch: 50 }, // Reason
  ];
};
